const eatingOut = ["0-1", "2-3", "4-5", "6 o más"];
export default eatingOut;
